// extracted by mini-css-extract-plugin
module.exports = {"root":"PageHeader_root__Fp9_7","container":"PageHeader_container__ZWd_7","description":"PageHeader_description__DpOri","button":"PageHeader_button__OVRjR"};